import { createContext, useContext, useEffect } from 'react';

/**
 * Lets a page declare that it renders a full-bleed hero the header should sit transparently
 * over (§25.2: "SiteHeader — transparent over hero / opaque white on inner pages").
 *
 * Only the Home page opts in today; inner pages use the rounded PageHero under an opaque
 * header, so they simply don't call the hook and the header stays solid.
 */
export const HeroHeaderContext = createContext<(active: boolean) => void>(() => {});

/** Marks the current page as having a full-bleed hero for as long as it is mounted. */
export function useHeroHeader(): void {
  const setHeroHeader = useContext(HeroHeaderContext);
  useEffect(() => {
    setHeroHeader(true);
    return () => setHeroHeader(false);
  }, [setHeroHeader]);
}
